<template>
  <UppyContextProvider :uppy="uppy">
    <div class="relative inline-block">
      <UppyDropzone />
      <DashboardModal
        :uppy="uppy"
        :open="open"
        :props="{
          onRequestCloseModal: handleClose,
        }"
      />
      <slot />
    </div>
  </UppyContextProvider>
</template>

<script setup>
import { defineComponent, h, ref } from 'vue';
import { UppyContextProvider, useDropzone } from '@uppy/vue';
import DashboardModal from '@uppy/vue/dashboard-modal';
import Uppy from '@uppy/core';
import AwsS3 from '@uppy/aws-s3';

const API_URL = window.location.origin + '/api/';

const props = defineProps({
  multiple: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([ 'uploaded' ]);

const open = ref(false);
const debug = false;
const UppyDropzone = defineComponent({
  name: 'UppyDropzone',

  setup() {
    const dropzone = useDropzone();

    return () => h('div', {
      class: 'absolute inset-0 z-10 overflow-hidden opacity-0',
      ...dropzone.getRootProps()
    }, [
      h('input', {
        class: 'hidden',
        ...dropzone.getInputProps()
      })
    ]);
  }
});

const uppy = new Uppy({ id: 'uppy', autoProceed: false, debug }).use(AwsS3, {
  id: 'myAWSPlugin',
  endpoint: API_URL,
  getTemporarySecurityCredentials: false,
  shouldUseMultipart: true,
  restrictions: {
    maxFileSize: 1000000,
    maxNumberOfFiles: props.multiple ? 30 : 1
  }
});
uppy.on('file-added', () => {
  open.value = true;
});
uppy.on('file-removed', () => {
  if (uppy.getFiles().length === 0) {
    open.value = false;
  }
});
uppy.on('complete', response => {
  if (response.successful.length > 0) {
    emit('uploaded', response.successful.map(obj => obj.uploadURL));
  }

  if (response.failed.length === 0) {
    handleClose();
  }
});

function handleClose() {
  uppy.clear();
  open.value = false;
}
</script>

<style scoped>
:deep(.uppy-Root) {
  width: 100%;
  height: 100%;
}
:deep(.uppy-DragDrop-container) {
  cursor: pointer;
}
</style>
